// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "80cd50010cee368fa628d2a92b179b9b58cb84cb/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","688":"2b6b0509","774":"c5660826","777":"dfb468f1"}[chunkId] + ".chunk.js";
};